/*
 * Layout for the mini Learner, which shows a smaller form of the learner results
 * for easy dragging and dropping into topics
 */

define([
  "marionette",
  "jquery",
  "modules/topicsSplit/miniLearner/template/miniLearnerTemplate.html",
], function (Marionette, $, MiniLearnerTemplate) {
  var MiniLearnerView = {};

  MiniLearnerView.miniLearnerLayout = Marionette.Layout.extend({
    className: "max-height",
    expanded: false,
    template: MiniLearnerTemplate,
    expand: function () {
      $("#miniLearner").animate({ right: "0px" }, function () {
        $("#miniLearnerToggle i").addClass("icon-chevron-right");
        $("#miniLearnerToggle i").removeClass("icon-chevron-left");
      });
      this.expanded = true;
    },
    hide: function () {
      var menuWidth = $("#miniLearner").width();
      $("#miniLearner").animate({ right: -menuWidth }, function () {
        $("#miniLearnerToggle i").removeClass("icon-chevron-right");
        $("#miniLearnerToggle i").addClass("icon-chevron-left");
      });
      this.expanded = false;
    },
    hideHighlightedTranscript: function () {
      this.$el.find("#miniLearnerResults").addClass("no-transcript");
    },
    events: {
      "click #miniLearnerToggle": function () {
        if (this.expanded) {
          this.hide();
        } else {
          this.expand();
        }
      },
    },
    onRender: function () {
      this.$el.i18n();
      //customize the tooltip placement since 'top' would send it off the screen
      this.$el.find('a[data-toggle="tooltip"], button[data-toggle="tooltip"]').tooltip({
        delay: { show: 333, hide: 0 },
        container: "body",
        placement: "left",
      });
    },
    regions: {
      miniLearnerResults: "#miniLearnerResults",
      highlightedTranscript: "#highlightedTranscriptArea",
    },
    showHighlightedTranscript: function () {
      this.$el.find("#miniLearnerResults").removeClass("no-transcript");
    },
    triggers: {
      "click #expandLearner": "expand:learner",
    },
  });

  return MiniLearnerView;
});
